import { Cpu, CookingPot, BrainCircuit, Network, Rocket, BookOpen, Sun, CheckCircle, Code, Leaf, Shield, Palette, Database, Dumbbell, Wifi, MessageCircle, Smartphone, Zap, PenTool, Map, Scale, FlaskConical, RotateCcw, Apple, Glasses, GitBranch, Share2, Cloud, Car, Droplets, Music, Camera, Lightbulb, Book, Activity, TestTube2, Briefcase, Home, Globe, Anchor, Feather, Moon } from 'lucide-react';

export interface Suggestion {
  text: string;
  icon: any;
}

export const chatSuggestions: Suggestion[] = [
  { text: "Explain the basics of quantum computing", icon: Cpu },
  { text: "Suggest a healthy and quick dinner recipe", icon: CookingPot },
  { text: "What are the benefits of mindfulness meditation?", icon: BrainCircuit },
  { text: "Summarize the theory of neural networks", icon: Network },
  { text: "Write a short story about a journey to Mars", icon: Rocket },
  { text: "Create a 5-step guide to learn machine learning", icon: BookOpen },
  { text: "How does photosynthesis work in simple terms?", icon: Sun },
  { text: "Give me three tips for a productive morning routine", icon: CheckCircle },
  { text: "What are the latest trends in web development?", icon: Code },
  { text: "Explain the impact of climate change on polar bears", icon: Leaf },
  { text: "How do vaccines train the immune system?", icon: Shield },
  { text: "What are the core principles of good UI/UX design?", icon: Palette },
  { text: "Find and remove duplicates in a SQL table", icon: Database },
  { text: "What are the long-term benefits of regular exercise?", icon: Dumbbell },
  { text: "How does the internet get to my house?", icon: Wifi },
  { text: "Discuss the ethical implications of AI in healthcare", icon: MessageCircle },
  { text: "Design a modern and accessible mobile app interface", icon: Smartphone },
  { text: "Compare solar, wind, and hydro renewable energy", icon: Zap },
  { text: "Write a short poem about the beauty of nature", icon: PenTool },
  { text: "How does GPS technology pinpoint a location?", icon: Map },
  { text: "Explain the concept of democracy in ancient Greece", icon: Scale },
  { text: "What is the scientific method and why is it important?", icon: FlaskConical },
  { text: "How to build a good habit that sticks", icon: CheckCircle },
  { text: "Write a function in Python to reverse a string", icon: RotateCcw },
  { text: "What are the cognitive benefits of reading books?", icon: Book },
  { text: "Explain the main differences between 4G and 5G", icon: Wifi },
  { text: "Create a balanced weekly meal plan for a vegetarian", icon: Apple },
  { text: "What is the difference between VR and AR?", icon: Glasses },
  { text: "How to use the STAR method for interview questions", icon: Briefcase },
  { text: "Explain the basics of Git and version control", icon: GitBranch },
  { text: "What are the psychological effects of social media?", icon: Share2 },
  { text: "Summarize the benefits of cloud computing for businesses", icon: Cloud },
  { text: "Why is biodiversity important for the ecosystem?", icon: Leaf },
  { text: "What will be the future of autonomous transportation?", icon: Car },
  { text: "Write a short story set in a futuristic underwater city", icon: Droplets },
  { text: "What are the key elements of music theory?", icon: Music },
  { text: "Give me some tips for taking better photos with a smartphone", icon: Camera },
  { text: "Explain the theory of general relativity like I'm five", icon: Lightbulb },
  { text: "What are the main causes of the Great Depression?", icon: Book },
  { text: "How can I improve my daily physical activity?", icon: Activity },
  { text: "Explain the role of DNA in genetics", icon: TestTube2 },
  { text: "How to create a compelling business plan", icon: Briefcase },
  { text: "Design a smart home system for energy efficiency", icon: Home },
  { text: "What are the cultural impacts of globalization?", icon: Globe },
  { text: "Explain the concept of a black hole to a child", icon: Moon },
  { text: "Write a haiku about the ocean's mysteries", icon: Anchor },
  { text: "Describe the life cycle of a butterfly", icon: Feather },
];

export const getRandomSuggestions = (count: number = 10): Suggestion[] => {
  const shuffled = [...chatSuggestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};